import { render, staticRenderFns } from "./Page5Chart1.vue?vue&type=template&id=63916fba&scoped=true&"
import script from "./Page5Chart1.vue?vue&type=script&lang=ts&"
export * from "./Page5Chart1.vue?vue&type=script&lang=ts&"
import style0 from "./Page5Chart1.vue?vue&type=style&index=0&id=63916fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63916fba",
  null
  
)

export default component.exports